import { useRef, useLayoutEffect } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { MNP_ROUTES } from "app/pages/digital-marketing/monitor-and-protect/app/navigation";

let savedScrollPosition = 0;

export const useScrollPositionRestore = () => {
    const { state } = useCurrentStateAndParams();
    const containerRef = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
        if (state.name !== MNP_ROUTES.competitors) {
            return;
        }

        if (savedScrollPosition && containerRef.current) {
            requestAnimationFrame(() => {
                if (containerRef.current) {
                    containerRef.current.scrollTop = savedScrollPosition;
                }
            });
        }

        return () => {
            if (containerRef.current) {
                savedScrollPosition = containerRef.current.scrollTop;
            }
        };
    }, [state.name]);

    return containerRef;
};
